var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-0" }, [
    _c("div", { staticClass: "right-inner-addon" }, [
      _c("i", { staticClass: "fa fa-search" }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.currentSearchString,
            expression: "currentSearchString",
          },
        ],
        staticClass: "form-control search-contacts",
        attrs: {
          id: "segment",
          type: "search",
          placeholder: _vm.$t("lists.segments.searchForAContact"),
          autocomplete: "off",
        },
        domProps: { value: _vm.currentSearchString },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.currentSearchString = $event.target.value
            },
            function ($event) {
              return _vm.handleSearch($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "d-none", attrs: { for: "segment" } }, [
        _vm._v(_vm._s(_vm.$t("global.words.segmentSearch"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }